<div class="desktop-container">
    <div class="min-w-0">
        <span class="intro min-w-0">
            @if (title) {
                @switch (title.type) {
                    @case ('title') {
                        {{title.value}}
                    }
                    @case ('date') {
                        {{title.value}}
                    }
                    @case ('airports') {
                        {{title.value[0]}}
                        <app-custom-icon
                            [iconPath]="'assets/icons/general-icons.svg'"
                            [imageName]="'icon-chevron-right'">
                            </app-custom-icon>
                        {{title.value[1]}}
                    }
                }
            }
        </span>
        <app-assigned-item-meta class="text-xs mt-1" [meta]="meta"></app-assigned-item-meta>
    </div>

    <p-tag
        [styleClass]="badgeStyleClass"
        [value]="badgeLabel"></p-tag>

    <app-flight-card-cta class="w-full" [flight]="flight" [type]="'flight'" [canBeArchived]="true" [asListRow]="true"></app-flight-card-cta>
</div>

<div class="mobile-container" (click)="$event.stopPropagation()">
    <app-flight-card-mobile [content]="'flex'">
        <ng-container title>
            @if (title) {
                @switch (title.type) {
                    @case ('title') {
                        {{title.value}}
                    }
                    @case ('date') {
                        {{title.value}}
                    }
                    @case ('airports') {
                        {{title.value[0]}}
                        <app-custom-icon
                            [iconPath]="'assets/icons/general-icons.svg'"
                            [imageName]="'icon-chevron-right'">
                        </app-custom-icon>
                        {{title.value[1]}}
                    }
                }
            }
        </ng-container>
        <app-frat-status status [flight]="flight"></app-frat-status>
        <ng-container subtitle>
            <div class="mt-3">
                <p-tag
                    [styleClass]="badgeStyleClass"
                    [value]="badgeLabel"></p-tag>
            </div>
        </ng-container>
        <ng-container content>
            <app-assigned-item-meta class="text-sm" [meta]="meta"></app-assigned-item-meta>
        </ng-container>
        <app-flight-card-cta class="w-full" actions [flight]="flight" [isEditable]="showEdit" [canBeArchived]="true" [asListRow]="true"></app-flight-card-cta>
    </app-flight-card-mobile>
</div>
